export default __webpack_public_path__ + "static/media/Edit.f886988a.svg";